import React, { useEffect, useState } from 'react';
import 'materialize-css/dist/css/materialize.min.css';
import './App.css';
import {addGraph,changeGraph,saveGraph} from '../MainScene';
import { treeGraph } from '../treeGraph.js'
import Menu from './Menu'
import HelpButton from './HelpButton'
import PinNodeToggle from './PinNodeToggle'
import BaseNumber from './BaseNumber'
import defaultTreeData from '../treeGraphData.js'

const maxNodes = 500;

function App() {
  const [baseNumber, setBaseNumber] = useState(1);
  const [powerNumber, setPowerNumber] = useState(1);

  useEffect( () => {
    let data = JSON.parse(localStorage.getItem('graph'));
    let graph;
    if(!data){
      data = defaultTreeData;
    }
    if(data){
      graph = treeGraph(0,0);
      let addedNodes = graph[0].loadData(data.root);
      graph = graph.concat(addedNodes);
      setBaseNumber(data.branches);
      setPowerNumber(data.generations);
    } else {
      graph = treeGraph(powerNumber,baseNumber);    
    }
    addGraph(graph);
  }, []);

  const updateGraph = (base, power) => {
    changeGraph(base,power);
  }

  const handleBaseNumber = (value) => {
    if(Math.pow(value, powerNumber) > maxNodes){
      setBaseNumber(baseNumber);
      return;
    }
    setBaseNumber(value);
    updateGraph(value, powerNumber);
  }

  const handlePowerNumber = (value) => {
    if(Math.pow(baseNumber, value) > maxNodes){
      setPowerNumber(powerNumber);
      return;
    }    
    setPowerNumber(value);
    updateGraph(baseNumber, value);
  }  

  const createNewGraph = () => {
    
  }
  
  return (
    <div className="App">
      <Menu/>
      <HelpButton handleClick={() => saveGraph(baseNumber,powerNumber)}/>
      {/* <SaveButton handleClick={() => saveGraph(baseNumber,powerNumber)}/> */}
      <div className='bottom-fixed'>
        <PinNodeToggle/>      
        <BaseNumber numberType='Branches' className='base-number' value={baseNumber} handleValueChange={handleBaseNumber}/>
        <BaseNumber numberType='Generations' className='power-number' value={powerNumber} handleValueChange={handlePowerNumber}/>
      </div>           
    </div>
  );
}

export default App;
